web = window.web = window.web || {};
web.CreditsDirector = window.web.CreditsDirector || {};

var $ = require('jquery');

web.creditsSectionManager = require('./section/Manager');
web.creditsSectionContentManager = require('./sectionContent/Manager');


web.creditsDirector = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.instances = {};

    t.options = $.extend({}, t.defaults, options);

    t.CSS_SELECTOR_PREFIX = ".js-credits-";

    t.activeSectionInstance = null;

    t.baseUrl = "";

    t.filter = [];

};

web.creditsDirector.prototype = {
    init:  function(){
        var t = this;
        t.instanceState = 'inicialized';

        //Vytvoření instancí
        t._constructInstances();

        //Bind událostí instacní
        t._bindEvents();

        //Set instances
        t._configInstances();

        //Vlastní procesy instancí
        t._initInstances();

        //Prejmout instance obecneho charakteru z weboveho direcotru
        t._receiveInstancesFromWebDirector();


        $(t).trigger({
            type: "inicialized"
        });
    },

    _constructInstances: function(){
        var t = this;
        t.instances = {
            sectionManager: new web.creditsSectionManager(),
            sectionContentManager: new web.creditsSectionContentManager(),

            paramResolver: new web.ParamResolver(),
            contentLoader: new web.ContentLoader(),
            anchorSlider: window.director.instances.anchorSlider,
            preloader: window.director.instances.preloader,
            slideLinks: window.director.instances.slideLinks,
            urlStateCommiter: window.director.instances.urlStateCommiter
        }
    },

    _receiveInstancesFromWebDirector: function(){
        var t = this;

        //t.instances.anchorSlider = window.director.instances.anchorSlider;
        //t.instances.preloader = window.director.instances.preloader;
        //t.instances.slideLinks = window.director.instances.slideLinks;
        //t.instances.urlStateCommiter = window.director.instances.urlStateCommiter;
    },

    _setBaseUrl: function(url){
        var t = this;

        t.baseUrl = url;
    },

    _bindEvents: function(){
        var t = this;
        t.instanceState = 'binded';

        //Vsechno je ready
        $(t).on("inicialized", function(){
            //t.instances.sectionManager.unsetAllActiveSections();
            //t.instances.sectionManager.setActiveSectionById("p.credits.2.1");


            //t.instances.sectionContentManager.unsetAllActiveSectionContents();
            //t.instances.sectionContentManager.showSectionContentById("p.credits.2");

            //t._setBaseUrl(t.activeSectionInstance.getUrl());
            //t.instances.urlStateCommiter.commitUrl(t.baseUrl);

            t._setParamResolver();
        });


        $(t.instances.sectionManager).on("activeSectionInstanceSet", function(e){

            var sectionContentInstancesToShow =  t.instances.sectionContentManager.getSectionContentById(e.activeSectionId);

            t.instances.sectionContentManager.unsetAllActiveSectionContents();
            t.instances.sectionContentManager.showSectionContentById(e.activeSectionId);

            t.activeSectionInstance = e.activeSectionInstance;
            t._setBaseUrl(t.activeSectionInstance.getUrl());
            t.instances.urlStateCommiter.commitUrl(t.baseUrl);

            t._clearAndCloseAllAffected();
        });


        /**
         *
         * TESTIMONIALS
         *
         */
        $(t.instances.contentLoader).on("xhrBeforeSend", function(e){
            t.instances.anchorSlider.scrollTo($("body"), 0);

            //t.instances.preloader.show();

        });


        $(t.instances.contentLoader).on("xhrComplete", function(e){
            //t.instances.preloader.hide();

        });

        var $testimonialButton = $(".js_testimoniaButton");

        $(t.instances.contentLoader).on("xhrSuccess", function(e){
            t.instances.slideLinks.processSlideLink({slideLinksTarget: "js_testimonialDetail"}, $testimonialButton);
            $(".js_testimonialList").fadeOut(500);

            t.instances.urlStateCommiter.commitUrl(e.contentUrl);


        });

        $("body").on("click", ".js_testimonialBack", function(e){
            t._closeTestimonial();

            e.preventDefault();
        });

        $("body").on("change", ".js_creditsFilter", function(){
            const tagsWithLightVariant = ["hawk", "minihawk"];
            const value = $(this).val();

            if ($(this).is(':checked')) {
              t.filter.push(value)
              if ($(window).width() > 480) {
                if (tagsWithLightVariant.includes(value)) {
                  $(this).next("label").find("img").attr("src", "/img/logos/" + value + "-b.svg")
                }
              }
            } else {
              t.filter = t.filter.filter((v) => v != value);
              if ($(window).width() > 480) {
                if (tagsWithLightVariant.includes(value)) {
                  $(this).next("label").find("img").attr("src", "/img/logos/" + value + ".svg")
                }
              }
            }
            t._filterCredits();
        });

        $("body").on("click", ".js_creditsFilterReset", function(){
            const tagsWithLightVariant = ["hawk", "minihawk"];

            $(".js_creditsFilter").each(function() {
                const value = $(this).val();

                if ($(this).is(':checked')) {
                    $(this).prop('checked', false);
                    if (tagsWithLightVariant.includes(value)) {
                        $(this).next("label").find("img").attr("src", "/img/logos/" + value + ".svg")
                    }
                }
            })

            t.filter = [];
            t._filterCredits();
        });

        $('.js_creditsFilterVisible').on('click', function(e) {
            $(".box-filter-container,.box-filter-results,.nav-tabs-filter--container-credits").fadeToggle( "hidden-phone show-phone", "linear" );
            $('.nav-tabs-filter--wrapper').toggleClass("show-filter");
            $('.nav-tabs-filter--container-hr--animated').toggleClass("nav-tabs-filter--container-hr--animate");
            e.preventDefault();
        });

        /**
         *
         * SLIDOVANI
         *
         */
        $(t.instances.slideLinks).on("beforeSlideDown", function(e){

            //Neko sliduje s movies detailem
            if($(e.slideElement).hasClass("movie-detail")){

                const minHeight = $("body").find(".movie-img").first().css('min-height');
                $("body").find(".movie-img").css({minHeight: minHeight});
                $("body").find(".movie-img").css({height: minHeight});

                var $btn = $(e.btnElement);
                var $btnParent = $btn.parent();

                //Find the tab and click him
                var $tabParent = $btn.parents("[id*='tab-']");
                var tabParentId = $tabParent.attr("id");
                $("a[href='#"+tabParentId+"']").click();

                var $triangel = $btnParent.find(".triangel");
                var $elm = $(e.slideElement);
                $elm.show();
                var top = $elm.position().top;

                /* Korekce marginu pro commercials */
                var itemsHeights = [];
                var items = [];
                var item1 = $btnParent.parent().next('.movie-item-wrap');
                if (item1.length > 0) {
                    items.push(item1.find('.movie-item-comercials'));
                }
                var item2 = item1.next('.movie-item-wrap');
                if (item2.length > 0) {
                    items.push(item2.find('.movie-item-comercials'));
                }
                var item3 = $btnParent.parent().prev('.movie-item-wrap');
                if (item3.length > 0) {
                    items.push(item3.find('.movie-item-comercials'));
                }
                var item4 = item3.prev('.movie-item-wrap');
                if (item4.length > 0) {
                    items.push(item4.find('.movie-item-comercials'));
                }

                $.each(items, function(i, item) {
                    itemsHeights.push($(item).outerHeight());
                });
                var maxHeight = Math.max.apply(null, itemsHeights);
                var margin = maxHeight - $btnParent.outerHeight(true);
                if (margin > 0) {
                    $elm.css("margin-top", margin + 20);
                    $triangel.css("top", margin);
                }
                var height = $elm.outerHeight();
                $elm.hide();

                var slideInterval = t.instances.slideLinks.getInterval();


                $btnParent.animate({
                    'margin-bottom': height
                }, slideInterval, function(){
                    $triangel.fadeIn(slideInterval/2);
                });



                var headerHeight = 0;
                if ($(".header-fixed").css("position") == "fixed") {
                    headerHeight = $(".header-fixed").outerHeight();
                }
                if (!!t.instances.paramResolver.getParams().scrollTo) {
                    if (t.instances.paramResolver.instanceState == 'resolvingExecuted') {
                        t.instances.anchorSlider.scrollTo($btn.find("img.movie-img"), -(headerHeight));
                    }
                } else {
                    t.instances.anchorSlider.scrollTo($btn.find("img.movie-img"), -(headerHeight));
                }

                t.instances.urlStateCommiter.commitUrl($btn.attr("href"));
            };

        });

        $(t.instances.slideLinks).on("afterSlideUp", function(e) {

            ////Neko sliduje s movies detailem
            //if ($(e.slideElement).hasClass("movie-detail")) {
            //    //t.instances.urlStateCommiter.commitUrl(t.baseUrl);
            //}
        });

        $(t.instances.slideLinks).on("beforeSlideUp", function(e) {

            //Neko sliduje s movies detailem
            if ($(e.slideElement).hasClass("movie-detail")) {
							  t.instances.urlStateCommiter.commitUrl(window.location.pathname.substr(0, window.location.pathname.lastIndexOf("/")));
            }
        });

    },

    _filterCredits: function() {
        var t = this;
        if (t.filter.length !== 0) {
            $(".js_creditsFilterItem").map((i, e) => {
                if (t.filter.every(f => e.hasAttribute('data-filter-' + f))) {
                    $(e).show()
                } else {
                    $(e).hide()
                }
            })
        } else {
            $(".js_creditsFilterItem").show();
        }
    },

    _closeTestimonial: function(){
        var t = this;
        var $testimonialButton = $(".js_testimoniaButton");

        if ($("#js_testimonialDetail").data("slideLinksOpened")) {
            t.instances.slideLinks.processSlideLink({slideLinksTarget: "js_testimonialDetail"}, $testimonialButton);
            $(".js_testimonialList").fadeIn(500);

            t.instances.urlStateCommiter.commitUrl(t.baseUrl);
        }
    },

    _clearAndCloseAllAffected: function(){
        var t = this;

        t.instances.slideLinks.closeAll();

        $('[data-filter-target]').removeClass("active");
        $('[data-filter]').show();

        t._closeTestimonial();
    },

    _configInstances: function(){
        var t = this;

        t.instances.sectionManager.setSelectorPrefix(t.CSS_SELECTOR_PREFIX);
        t.instances.sectionContentManager.setSelectorPrefix(t.CSS_SELECTOR_PREFIX);
        t.instances.contentLoader.setSelectorPrefix(t.CSS_SELECTOR_PREFIX+"content-loader-");
    },

    _initInstances: function(){
        var t = this;
        for (var i in t.instances) {
            if (t.instances[i] !== window.director.instances[i]) {
                t.instances[i].init();
            }
        }
    },

    _setParamResolver: function() {
        var t = this;
        if (typeof t.instances.paramResolver.getParams().open !== 'undefined') {
            var $elm = $("[href$='" + t.instances.paramResolver.getParams().open + "']");
            if ($elm.length === 0) {
                $elm = $("[href$='" + t.instances.paramResolver.getParams().open.replace("_", "-") + "']");
            }
            $elm.click();
        }
        t.instances.paramResolver.executeParamsResolving();
    }

};




// WEBPACK FOOTER //
// ./fe/web-default/src/js/credits/Director.js